<form #searchForm="ngForm">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>Search</mat-card-title>
      <mat-card-subtitle
        >Please, select the scope and then enter the term for
        searching</mat-card-subtitle
        >
      </mat-card-header>

      <mat-card-content>
        <mat-radio-group (change)="onSelectionChange($event)" color="primary">
          @for (type of searchTypes; track type) {
            <mat-radio-button
              class="radio-button"
              [checked]="selectedSearchType == type"
              [value]="type"
              >{{ type }}
            </mat-radio-button>
          }
        </mat-radio-group>

        <mat-form-field appearance="outline">
          <mat-label>Search Term</mat-label>
          <form (keydown)="onKeyDown($event)">
            <input
              id="search-input"
              [(ngModel)]="searchText"
              matInput
              type="text"
              name="searchText"
              required
              />
            </form>
          </mat-form-field>
        </mat-card-content>

        <mat-card-actions>
          <button (click)="cancel()" mat-button>CANCEL</button>
          <button
            #searchButton
            [disabled]="!searchForm.form.valid"
            (click)="search()"
            mat-button
            color="primary"
            >
            SEARCH
          </button>
        </mat-card-actions>
      </mat-card>
      <form></form>
    </form>
